import transportHttpService from '../_services/transportHttpService'
import { GET_PJSIP_TRANSPORT } from './mutation-types'

export default {
  buscarPjsipTransport: async ({ commit }) => {
    try {
      const response = await transportHttpService.getPjsipTransport()
      commit(GET_PJSIP_TRANSPORT, response.data)
    } catch (error) {
      console.log(error)
    }
  },
}
